module.exports = __webpack_public_path__ + "static/img/about-ad1.ccad11f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutImg/about-ad1.jpg
// module id = NS0O
// module chunks = 3